// extracted by mini-css-extract-plugin
export default {"container":"Crown_container__S+zca","tooltip":"Crown_tooltip__3xgwF"};